import styled from "styled-components/macro";
import TagsGrid from "./TagsGrid";
import { Button, IconButton, Modal } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { AllocationObj } from "types/types";
import { HubletTag } from "../supervisorContextUtils";
import { ArrowBack } from "@mui/icons-material";

export function TagsGridModal({
  /** formState is used in TagsGrid to disable tags
   * that have already been selected. Only pass
   * formState if we need to disable selected tags. */
  formState = undefined,
  handleFinalTagClick,
  hubletTags,
  isTagsGridOpen,
  setIsTagsGridOpen,
}: {
  formState?: AllocationObj[];
  handleFinalTagClick: (tag: HubletTag) => void;
  hubletTags: HubletTag[];
  isTagsGridOpen: boolean;
  setIsTagsGridOpen: (newIsTagsGridOpen: boolean) => void;
}) {
  return (
    <Modal
      open={isTagsGridOpen}
      onClose={() => {
        setIsTagsGridOpen(false);
      }}
      style={{ position: "fixed", top: 0 }}
      disableScrollLock={true}
    >
      <TagsGridModalContentStyles>
        <div className="modalAndBtnClose">
          <IconButton
            onClick={() => {
              setIsTagsGridOpen(false);
            }}
            className="btnCloseModal"
            size="large"
          >
            <Close />
          </IconButton>

          <TagsGrid
            {...{
              formState,
              handleFinalTagClick,
              hubletTags,
              CustomBackButtonComponent: props => (
                <Button
                  className="btnBackBottom"
                  variant="contained"
                  startIcon={<ArrowBack />}
                  {...props}
                  style={{}}
                >
                  Back
                </Button>
              ),
            }}
          />
        </div>
      </TagsGridModalContentStyles>
    </Modal>
  );
}

const TagsGridModalContentStyles = styled.div`
  max-width: 900px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 64px);
  .modalAndBtnClose {
    position: relative;
    .btnCloseModal {
      position: absolute;
      top: -48px;
      right: -48px;
      color: white;
      z-index: 1;
      transform: scale(2);
      @media (max-width: 500px) {
        right: 0;
      }
    }
    .btnBackBottom {
      position: absolute;
      bottom: -56px;
      left: 0;
      right: 0;
      color: white;
      background: black;
      z-index: 1;
      width: fit-content;
      margin: auto;
      text-transform: none;
      font-size: 24px;
      padding: 2px 16px;
    }
  }
`;
